import { ActionButton, BaseTable, Button, Input, Modal, Textarea } from "components"
import { useContext, useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { PictureType, pictureValidation, useGetCodePicture } from "../../utils"
import { FormDataContext } from "../../context"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { yupResolver } from "@hookform/resolvers/yup"

export interface DataType {
    asset_picture_code?: string;
    asset_picture_name?: string;
    description?: string;
    path_picture?: string;
    asset_picture_id?: number
}

export function FormPicture() {

    return (
        <section className="py-5 px-6">
            <div className="w-full flex-col flex gap-8">
                <ThumbnailSection />
                <TableListPicture />
            </div>
        </section>
    )
}

function ThumbnailSection() {
    const { dataAsset } = useContext(FormDataContext);
    const { REACT_APP_BASE_URL_API } = process.env;

    const image = dataAsset?.pictures[dataAsset?.pictures.length - 1]?.path_picture

    return (
        <div className="border-[1px] border-inherit mb-5 flex items-center justify-center">
            <div className="flex justify-center">
                <div className="avatar my-4">
                    <div className="w-[250px] rounded">
                        <img src={`${image ? `${REACT_APP_BASE_URL_API}/getimage/?imgpath=${image}` : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2sRHjqz3RQ4yNTs7OKrn_JP0aRuLjMCHGPXoWUZriow&s'} `} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

function TableListPicture() {
    const { dataAsset, refecth } = useContext(FormDataContext);
    const api = useApi()

    const [modalValue, setModalValue] = useState<{
        modal?: boolean;
        action?: string;
        data?: DataType;
    }>({
        modal: false,
        action: "",
        data: {}
    });

    const [changeValue, setChange] = useState<string>("")

    const dataFilter = dataAsset?.pictures.filter((item) => item.asset_picture_name.toLowerCase().includes(changeValue.toLowerCase()))


    const onDelete = (pictureId: number) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.delete(`/assetdepre/detele_picture?asset_picture_id=${pictureId}`),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then((res) => {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                refecth()
            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <>
            <div className="flex justify-between">
                <Input inputClass="w-[300px]" placeholder="Search..." onChange={(e) => {setChange(e.target.value)}}  />
                <Button
                    type="button"
                    className="!none mb-5"
                    color="primary"
                    onClick={() =>
                        setModalValue({
                            modal: true,
                            action: "CREATE",
                            data: {
                                asset_picture_code: "",
                                asset_picture_name: "",
                                description: "",
                                path_picture: ""
                            }
                        })
                    }
                >
                    INSERT PICTURE
                </Button>
            </div>

            <div className="overflow-x-auto">
                <BaseTable>
                    <thead className="!bg-black !text-white">
                        <tr>
                            <th>NO</th>
                            <th>PICTURE ID</th>
                            <th>FILE NAME</th>
                            <th>DESCRIPTION</th>
                            <th>FILE PATH</th>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataFilter?.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.asset_picture_code}</td>
                                <td>{item.asset_picture_name}</td>
                                <td>{item.description}</td>
                                <td>{item.path_picture}</td>
                                <td className="">
                                    <ActionButton.Update
                                        onClick={() => {
                                            setModalValue({
                                                modal: true,
                                                action: "UPDATE",
                                                data: {
                                                    asset_picture_code: item.asset_picture_code,
                                                    asset_picture_name: item.asset_picture_name,
                                                    description: item.description,
                                                    path_picture: item.path_picture,
                                                    asset_picture_id: Number(item.asset_picture_id)
                                                }
                                            });
                                        }}
                                    />
                                    <ActionButton.Delete
                                        onClick={() => {
                                            onDelete(Number(item.asset_picture_id));
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </BaseTable>
            </div>

            {modalValue.modal && (
                <ModalSection modalValue={modalValue} setModalValue={setModalValue} />
            )}
        </>
    );
}

function ModalSection(props: {

    modalValue: {
        modal?: boolean;
        action?: string;
        data?: DataType
    };
    setModalValue: React.Dispatch<React.SetStateAction<{
        modal?: boolean;
        action?: string;
        data?: {
            asset_picture_code?: string;
            asset_picture_name?: string;
            description?: string;
            path_picture?: string;
        };
    }>>
}) {
    const { REACT_APP_BASE_URL_API } = process.env;

    const api = useApi()

    // context
    const { dataAsset, refecth: refetchAsset } = useContext(FormDataContext)

    // variabels
    const defaultValues: PictureType = {
        asset_picture_code: "",
        asset_picture_name: dataAsset?.asset_code ?? "",
        description: "",
        asset_foto: [],
        asset_picture_id: 0
    }

    const [imageViews, setImageView] = useState<{ file: File | null; view: string | null }>({ file: null, view: null })

    // hooks
    const { code, refetch } = useGetCodePicture()

    // use form
    const method = useForm<PictureType>({
        defaultValues: defaultValues,
        resolver: yupResolver(pictureValidation)
    })


    useEffect(() => {
        if (code && props.modalValue.action === "CREATE") {
            method.setValue("asset_picture_code", code)
        }
        // eslint-disable-next-line
    }, [code, props.modalValue.action])

    const onSubmit = (data: PictureType) => {
        const formData = new FormData()
        const finalData = {
            ...data,
            asset_id: dataAsset?.asset_id,
            ...(props.modalValue.action === "UPDATE" && { asset_picture_id: props.modalValue.data?.asset_picture_id })
        };

        Object.entries(finalData).forEach(([key, value]) => {
            if (value instanceof File || value instanceof Blob) {
                formData.append(key, value);
            } else {
                formData.append(key, String(value));
            }
        })

        if (!data.asset_foto || !(data.asset_foto instanceof File)) {
            formData.delete("asset_foto");
        }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post(`/assetdepre/asset_picture`, formData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then((res) => {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                refetch()
                refetchAsset()
                method.reset()
                props.setModalValue({ ...props.modalValue, modal: false })
            }).catch(() => { }).finally(resolve)
        })
    }

    useEffect(() => {
        if (props.modalValue.action === "UPDATE" && props.modalValue.data) {
            method.setValue("asset_picture_code", props.modalValue.data.asset_picture_code ?? "")
            method.setValue("asset_picture_name", props.modalValue.data.asset_picture_name ?? "")
            method.setValue("description", props.modalValue.data.description ?? "")
            method.setValue("asset_foto", props.modalValue.data.path_picture ?? "")
        }
        // eslint-disable-next-line
    }, [props.modalValue]);



    return (
        <Modal
            isOpen
            title="INSERT PICTURE"
            size="xl"
            closeModal={() => props.setModalValue({ ...props.modalValue, modal: false, action: "" })}
        >
            <Modal.Body>
                <div className="text-end">
                    Attention:{" "}
                    <span className="text-red-600">Please make sure your picture doesn't exceed 300 KB</span>
                </div>
                <section>
                    <Controller
                        control={method.control}
                        name="asset_picture_code"
                        render={({ field, fieldState }) => (
                            <Input {...field} label="ID PICTURE" value={field.value ?? ""} error={fieldState.error?.message} disabled />
                        )}
                    />

                    <Controller
                        control={method.control}
                        name="asset_picture_name"
                        render={({ field, fieldState }) => (
                            <Input {...field} label="FILE NAME" value={field.value ?? ""} onChange={(e) => field.onChange(e.target.value)} error={fieldState.error?.message} />
                        )}
                    />

                    <Controller
                        control={method.control}
                        name="description"
                        render={({ field, fieldState }) => (
                            <Textarea {...field} label="DESCRIPTION" value={field.value ?? ""} onChange={(e) => field.onChange(e.target.value)} error={fieldState.error?.message} />
                        )}
                    />

                    <div className="my-3">
                        <div className="w-full !rounded-lg bg-primary h-[50px]">
                            <Controller
                                control={method.control}
                                name="asset_foto"
                                render={({ field }) => (
                                    <input
                                        className="w-full h-full flex justify-center items-center opacity-0 cursor-pointer"
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const selectedFile = e.target.files?.[0];
                                            if (selectedFile) {
                                                if (selectedFile.size > 300 * 1024) {
                                                    alert("Image size maximum 300KB");
                                                    return;
                                                }
                                                
                                                method.setValue("asset_foto", selectedFile);

                                                setImageView({ ...imageViews, file: selectedFile ?? method?.watch("asset_foto") });
                                                const reader = new FileReader();
                                                reader.onloadend = () => setImageView({ ...imageViews, view: reader.result as string });
                                                reader.readAsDataURL(selectedFile);

                                                method.setValue("asset_foto", selectedFile);
                                            }
                                            field.onChange(selectedFile);
                                        }}
                                    />
                                )}
                            />
                            <div className="mt-[-35px] text-black flex justify-center">
                                <b>PICTURE</b>
                            </div>
                        </div>
                        <img
                            className="w-full mt-3 rounded-lg"
                            alt=""
                            src={
                                imageViews?.view 
                                ? imageViews?.view
                                : method?.watch("asset_foto")
                                ? `${REACT_APP_BASE_URL_API}/getimage/?imgpath=${method?.watch("asset_foto")}`
                                : ""
                            }
                        />
                    </div>
                </section>
            </Modal.Body>

            <Modal.Footer className="text-end">
                <Button type="button" color="primary" onClick={method.handleSubmit(onSubmit)} loading={method.formState.isSubmitting ? "true" : undefined}>
                    {props.modalValue.action === "UPDATE" ? "UPDATE" : "CREATE"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
